import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

service.interceptors.request.use(
  config => {
    console.log('request info success => ', config)
    return config
  },
  error => {
    console.log('request info error => ', error.response)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    console.log('response info success => ', response)
    if (response.data.code != 0) {
      Message({
        message: response.data.message || response.data.msg || 'Error',
        type: 'error',
        duration: 3000
      })
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  error => {
    console.log('response info error => ', error.response)
    const errData = error.response.data
    if (error.response.status === 401 || error.response.status === 402 || error.response.status === 403) {
      return Promise.reject(error)
    }
    if (errData.code !== 60014) {
      Message({
        message: errData.msg || errData.message || 'Error',
        type: 'error',
        duration: 3000
      })
    }
    return Promise.reject(error)
  }
)

export default service
